import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Button from '../../../components/Button';
import styles from './highlight.scss';

const propTypes = {
  icon: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  colors: PropTypes.shape({
    button: PropTypes.string,
    icon: PropTypes.string,
  }),
  glow: PropTypes.bool,
};

const Highlight = ({
  icon,
  action,
  description,
  button,
  onClick,
  colors,
  glow,
}) => (
  <div
    className={classNames(
      styles.highlight,
      { [styles.glow]: glow },
    )}
    onClick={onClick}
    role="button"
    tabIndex={0}
  >
    <div className={styles.icon}>
      <i
        className={`far fa-${icon}`}
        style={(colors && colors.icon) ? { color: `${colors.icon}` } : {}}
      />
    </div>
    <div className={styles.content}>
      <div className={styles.action}>
        {action}
      </div>
      <div className={styles.description}>
        {description}
      </div>
      <Button
        outline={!(colors && colors.button)}
        colors={(colors && colors.button) ? { background: `${colors.button}` } : {}}
      >
        {button}
      </Button>
    </div>
  </div>
);

Highlight.propTypes = propTypes;

export default Highlight;
